import React, { useEffect, useRef } from 'react';
import { Check, X } from 'lucide-react';

interface ToastProps {
  message: string;
  onClose: () => void;
  onUndo?: () => void;
  duration?: number;
}

export function Toast({ message, onClose, onUndo, duration = 5000 }: ToastProps) {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [duration, onClose]);

  return (
    <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-[300]">
      <div className="bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-3">
        <Check className="w-4 h-4" />
        <span className="text-sm font-medium">{message}</span>
        {onUndo && (
          <button
            onClick={(e) => {
              e.preventDefault();
              onUndo();
              onClose();
            }}
            className="text-sm font-medium text-white/80 hover:text-white transition-colors ml-2"
          >
            Undo
          </button>
        )}
        <button
          onClick={onClose}
          className="ml-2 p-1 hover:bg-white/10 rounded-full transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}